import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const BoostSolidIconBrand = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'>
) => {
  return (
    <SvgWrapper
      viewBox="0 0 56 56"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="url(#paint0_linear_5072_30194)" />
      <g filter="url(#filter0_d_5072_30194)">
        <path
          d="M25.5542 14.6274C27.7749 11.5716 32.6073 13.1013 32.6655 16.8784L32.7534 22.5894H36.9878C40.1803 22.5894 42.0417 26.1931 40.1938 28.7964L30.7983 42.0308C28.5809 45.1541 23.661 43.5857 23.6606 39.7554V34.0562H19.1528C15.9403 34.0562 14.0837 30.4118 15.9722 27.813L25.5542 14.6274ZM31.0278 16.9038C30.9939 14.7005 28.1748 13.8078 26.8794 15.5903L17.2974 28.7769L17.2476 28.8481C16.2463 30.3344 17.2741 32.3524 19.0649 32.4165L19.1528 32.4185H24.3159C24.8587 32.4185 25.2993 32.8581 25.2993 33.4009V39.7554L25.3013 39.8589C25.3872 41.9832 28.1011 42.8481 29.4009 41.1655L29.4624 41.0825L38.8579 27.8481C39.919 26.3533 38.8836 24.2931 37.0747 24.229L36.9878 24.2271H32.1089L32.0591 24.2261C31.562 24.2012 31.1612 23.8067 31.1284 23.3101L31.1255 23.2593L31.0278 16.9038ZM27.769 17.4331C28.2639 16.7399 29.3565 17.0894 29.3569 17.9409V25.0552C29.357 25.5385 29.7486 25.93 30.2319 25.9302H36.2563C36.9683 25.9304 37.382 26.7355 36.9683 27.3149L28.4878 39.1938C27.9928 39.8872 26.8999 39.5369 26.8999 38.6851V31.5718C26.8999 31.0882 26.5075 30.6958 26.0239 30.6958H20.0005C19.2885 30.6958 18.874 29.8915 19.2876 29.312L27.769 17.4331Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5072_30194"
          x="5.21411"
          y="3.00024"
          width="45.7122"
          height="50.6936"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5072_30194"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5072_30194"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5072_30194"
          x1="56"
          y1="56"
          x2="0"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#671DE7" />
          <stop offset="1" stopColor="#D4B9FF" />
        </linearGradient>
      </defs>
    </SvgWrapper>
  );
};
